import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "absolute inset-0 pointer-events-none overflow-hidden" }
const _hoisted_2 = { class: "max-w-3xl mx-auto relative z-10" }
const _hoisted_3 = { class: "text-center mb-10" }
const _hoisted_4 = { class: "text-3xl md:text-4xl font-bold mb-4" }
const _hoisted_5 = { class: "galaxy-text-gradient" }
const _hoisted_6 = { class: "p-[2px] rounded-2xl bg-nebula-gradient shadow-glow-lg" }
const _hoisted_7 = { class: "flex-1 flex justify-center" }
const _hoisted_8 = {
  key: 0,
  class: "space-y-3 p-6 animate-pulse"
}
const _hoisted_9 = ["title"]

import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'RegistrationForm',
  props: {
    isDark: { type: Boolean }
  },
  setup(__props: any) {



const { t } = useI18n()
const iframeLoading = ref(true)

const trustBadges = computed(() => [
  { icon: 'verified', label: t('registration.trust.certified') },
  { icon: 'schedule', label: t('registration.trust.response') },
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    id: "register",
    class: _normalizeClass(["section-padding relative overflow-hidden transition-colors duration-500", __props.isDark ? 'galaxy-section-alt-dark' : 'galaxy-section-alt-light'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["absolute top-0 left-1/4 w-96 h-96 rounded-full blur-3xl opacity-10", __props.isDark ? 'bg-nebula-purple' : 'bg-primary-200'])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["absolute bottom-0 right-1/4 w-80 h-80 rounded-full blur-3xl opacity-10", __props.isDark ? 'bg-nebula-cyan' : 'bg-accent-200'])
      }, null, 2),
      _createElementVNode("div", {
        class: _normalizeClass(["absolute top-1/2 left-0 w-64 h-64 rounded-full blur-3xl opacity-5", __props.isDark ? 'bg-nebula-pink' : 'bg-secondary-200'])
      }, null, 2)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-sm font-semibold mb-4 border", __props.isDark
            ? 'bg-nebula-purple/10 border-nebula-purple/30 text-nebula-cyan'
            : 'bg-primary-50 border-primary-200 text-primary-700'])
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "material-icons text-base" }, "star", -1)),
          _createTextVNode(" " + _toDisplayString(_unref(t)('registration.badge')), 1)
        ], 2),
        _createElementVNode("h2", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('registration.sectionTitle')), 1)
        ]),
        _createElementVNode("p", {
          class: _normalizeClass(["text-lg max-w-xl mx-auto leading-relaxed", __props.isDark ? 'text-galaxy-200' : 'text-gray-600'])
        }, _toDisplayString(_unref(t)('registration.subtitle')), 3)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["rounded-2xl overflow-hidden", __props.isDark ? 'bg-space-800/95' : 'bg-white/98'])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["px-6 py-4 flex items-center gap-3 border-b", __props.isDark ? 'border-galaxy-700/30 bg-space-900/60' : 'border-gray-100 bg-primary-50/60'])
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex gap-1.5" }, [
              _createElementVNode("span", { class: "h-3 w-3 rounded-full bg-nebula-pink/80" }),
              _createElementVNode("span", { class: "h-3 w-3 rounded-full bg-star-gold/80" }),
              _createElementVNode("span", { class: "h-3 w-3 rounded-full bg-nebula-cyan/80" })
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex items-center gap-2 text-xs font-medium px-3 py-1 rounded-full", __props.isDark ? 'bg-galaxy-800/60 text-galaxy-200' : 'bg-white text-gray-500 border border-gray-200'])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["material-icons text-xs", __props.isDark ? 'text-nebula-cyan' : 'text-primary-500'])
                }, "lock", 2),
                _createTextVNode(" forms.gle · " + _toDisplayString(_unref(t)('registration.secureForm')), 1)
              ], 2)
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["flex flex-wrap justify-center gap-x-6 gap-y-2 px-6 py-4 border-b", __props.isDark ? 'border-galaxy-700/20 bg-space-800/40' : 'border-gray-100 bg-gray-50/50'])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trustBadges.value, (badge) => {
              return (_openBlock(), _createElementBlock("div", {
                key: badge.icon,
                class: _normalizeClass(["flex items-center gap-1.5 text-xs font-medium", __props.isDark ? 'text-galaxy-300' : 'text-gray-500'])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["material-icons text-sm", __props.isDark ? 'text-nebula-cyan' : 'text-primary-500'])
                }, _toDisplayString(badge.icon), 3),
                _createTextVNode(" " + _toDisplayString(badge.label), 1)
              ], 2))
            }), 128))
          ], 2),
          (iframeLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: _normalizeClass(["h-8 rounded-lg w-1/2 mx-auto mb-6", __props.isDark ? 'bg-galaxy-700/50' : 'bg-gray-200'])
                }, null, 2),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
                  return _createElementVNode("div", {
                    key: n,
                    class: _normalizeClass(["h-10 rounded-lg", [__props.isDark ? 'bg-galaxy-700/40' : 'bg-gray-100', n % 3 === 0 ? 'w-3/4' : 'w-full']])
                  }, null, 2)
                }), 64)),
                _createElementVNode("div", {
                  class: _normalizeClass(["h-20 rounded-lg w-full mt-2", __props.isDark ? 'bg-galaxy-700/40' : 'bg-gray-100'])
                }, null, 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["h-10 rounded-full w-40 mx-auto mt-4", __props.isDark ? 'bg-galaxy-600/50' : 'bg-primary-200'])
                }, null, 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(iframeLoading.value ? 'h-0 overflow-hidden' : '')
          }, [
            _createElementVNode("iframe", {
              src: "https://docs.google.com/forms/d/e/1FAIpQLSciG2di4l2bSbJZi0c2a0JZF7tPHaEOKJY0zRtgz5nB1D71YQ/viewform?embedded=true",
              title: _unref(t)('registration.formTitle'),
              width: "100%",
              height: "3359",
              frameborder: "0",
              marginheight: "0",
              marginwidth: "0",
              loading: "lazy",
              class: "block w-full",
              style: {"min-height":"400px"},
              onLoad: _cache[0] || (_cache[0] = ($event: any) => (iframeLoading.value = false))
            }, _toDisplayString(_unref(t)('registration.iframeLoading')), 41, _hoisted_9)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["px-6 py-3 flex items-center justify-center gap-2 border-t", __props.isDark ? 'border-galaxy-700/30 bg-space-900/60' : 'border-gray-100 bg-gray-50/60'])
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["material-icons text-sm", __props.isDark ? 'text-nebula-cyan' : 'text-primary-500'])
            }, "verified_user", 2),
            _createElementVNode("p", {
              class: _normalizeClass(["text-xs", __props.isDark ? 'text-galaxy-400' : 'text-gray-400'])
            }, _toDisplayString(_unref(t)('registration.privacyNote')), 3)
          ], 2)
        ], 2)
      ])
    ])
  ], 2))
}
}

})